export function trackEvent(name, parameters = {}) {
  if (typeof window === "undefined") return;

  window.gtag?.("event", name, parameters);
}
